import { INDUSTRY_SUGGESTIONS_LIMIT_INDEX } from "app/pages/sales-intelligence/domain/industry/constants/suggestions";
import type { IndustryAffinityIndex } from "app/pages/sales-intelligence/domain/industry/types/affinity";
import type {
    IndustryNodeId,
    IndustryTaxonomyIndex,
} from "app/pages/sales-intelligence/domain/industry/types/taxonomy";
import {
    nextSuggestionReplacement,
    rankIndustryAffinitySuggestions,
} from "app/pages/sales-intelligence/domain/industry/utils/affinitySuggestions";

import type { IndustrySuggestionsViewModel } from "./IndustrySuggestionsViewModel";

type FactoryDeps = {
    readonly values: readonly IndustryNodeId[];
    readonly taxonomy: IndustryTaxonomyIndex;
    /** Absent until the affinity config has loaded. */
    readonly affinity: IndustryAffinityIndex | undefined;
    readonly dismissedIds: readonly IndustryNodeId[];
};

export const createIndustrySuggestionsViewModel = ({
    values,
    taxonomy,
    affinity,
    dismissedIds,
}: FactoryDeps): IndustrySuggestionsViewModel => {
    const rank = (dismissed: readonly IndustryNodeId[]) =>
        affinity ? rankIndustryAffinitySuggestions({ values, taxonomy, affinity, dismissed: new Set(dismissed) }) : [];

    const pool = rank(dismissedIds);
    const suggestionById = new Map(pool.map((suggestion) => [suggestion.id, suggestion]));

    return {
        topIds: pool.slice(0, INDUSTRY_SUGGESTIONS_LIMIT_INDEX).map((suggestion) => suggestion.id),
        resolve: (visibleIds) => visibleIds.flatMap((id) => suggestionById.get(id) ?? []),
        replacementFor: (id, visibleIds) => nextSuggestionReplacement(rank([...dismissedIds, id]), visibleIds),
    };
};
